var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elements",
    d: "M5.83301 15.5007V13.4173M5.83301 13.4173V12.1673C5.83301 11.7745 5.83301 11.5781 5.96115 11.456C6.08929 11.334 6.29553 11.334 6.70801 11.334H7.29134C7.8954 11.334 8.38509 11.8004 8.38509 12.3757C8.38509 12.9509 7.8954 13.4173 7.29134 13.4173H5.83301ZM17.4997 11.334H16.4059C15.7185 11.334 15.3747 11.334 15.1612 11.5374C14.9476 11.7408 14.9476 12.0681 14.9476 12.7229V13.4173M14.9476 15.5007V13.4173M14.9476 13.4173H16.7705M13.1247 13.4173C13.1247 14.5679 12.1453 15.5007 10.9372 15.5007C10.6646 15.5007 10.5283 15.5007 10.4268 15.4448C10.1837 15.3112 10.208 15.0406 10.208 14.8062V12.0284C10.208 11.794 10.1837 11.5235 10.4268 11.3898C10.5283 11.334 10.6646 11.334 10.9372 11.334C12.1453 11.334 13.1247 12.2667 13.1247 13.4173Z",
    stroke: "#337CC1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "elements_2",
    d: "M12.5003 18.834H8.93972C6.22205 18.834 4.86321 18.834 3.91955 18.1691C3.64918 17.9786 3.40914 17.7527 3.20674 17.4982C2.50033 16.6101 2.50033 15.3312 2.50033 12.7734V10.6522C2.50033 8.18286 2.50033 6.9482 2.89111 5.96211C3.51934 4.37684 4.84794 3.12639 6.53229 2.53511C7.58002 2.16732 8.89184 2.16732 11.5155 2.16732C13.0147 2.16732 13.7643 2.16732 14.363 2.37748C15.3255 2.71536 16.0847 3.4299 16.4437 4.33577C16.667 4.89925 16.667 5.60477 16.667 7.0158V8.83398",
    stroke: "#337CC1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "elements_3",
    d: "M2.49967 10.5C2.49967 8.96588 3.74333 7.72222 5.27745 7.72222C5.83227 7.72222 6.48637 7.81944 7.02581 7.6749C7.50511 7.54647 7.87948 7.1721 8.0079 6.6928C8.15245 6.15336 8.05523 5.49926 8.05523 4.94444C8.05523 3.41032 9.29888 2.16667 10.833 2.16667",
    stroke: "#337CC1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c22cab60f2cbe8fedf362174e71ef6e3.svg";
export { ForwardRef as ReactComponent };